import {useParams, Navigate} from 'react-router-dom'

const RedirectComponent = () => {

const {labID} = useParams();

return (
    <>
    <Navigate to={`/search/?lab=${labID}`} replace={true} />
    </>
)
}

export default RedirectComponent;